import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M17.241 3L12 8.241L13.026 9.267L16.5 5.793V21H18V5.811L21.4567 9.267L22.4827 8.241L17.241 3Z" }),
    React.createElement("path", { d: "M7.48275 18.207V3H5.98275V18.189L2.526 14.733L1.5 15.759L6.74175 21L11.9827 15.759L10.9567 14.733L7.48275 18.207Z" })), 'ChangeOrder');
